import { Component, OnInit, Inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import Env from '@ridango/core/env';
import { BaseComponent } from '@ridango/core';
import { Observable } from 'rxjs';
import { ShoppingCartIconService } from '@ridango/components/lib/shopping-cart/shopping-cart-icon.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'gl-header-shopping-cart-v2',
    templateUrl: './header-shopping-cart-v2.component.html'
})
export class HeaderShoppingCartV2Component extends BaseComponent implements OnInit {
    timer$: Observable<string>;
    count = 0;
    showWarningDialog = false;
    showEmptiedDialog = false;
    constructor(
        @Inject('ENV') public env: Env,
        private shoppingCartIconService: ShoppingCartIconService,
        private router: Router,
        private translate: TranslateService
    ) {
        super();
    }

    ngOnInit() {
        this.shoppingCartIconService.shoppingCartCountValue
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((count) => {
                this.count = count;
            });
        this.shoppingCartIconService.timer$.subscribe((timer) => {
            if (timer === '02:00') {
                this.showWarningDialog = true;
            }
            if (timer === '00:00') {
                this.showWarningDialog = false;
            }
        });
        this.shoppingCartIconService.timer$.subscribe((timer) => {
            if (timer === '00:00') {
                this.showEmptiedDialog = true;
                this.count = 0;
            }
        });
        this.timer$ = this.shoppingCartIconService.timer$;
    }

    getCount() {
        return this.count ?? '0';
    }

    handleClose() {
        this.showWarningDialog = false;
        this.showEmptiedDialog = false;
    }

    handleGoToCart() {
        this.showWarningDialog = false;
        this.router.navigate([this.translate.currentLang, 'purchase-v2', 'cart']);
    }
}
